import type { CSSProperties, ReactNode } from "react";

export interface StickerProps {
  /** Face colour of the vinyl. */
  face?: string;
  faceText?: string;
  tilt?: number;
  shape?: "rect" | "round";
  size?: "md" | "sm";
  peelable?: boolean;
  className?: string;
  faceClassName?: string;
  style?: CSSProperties;
  children?: ReactNode;
  /** Extra content placed on the backing paper, under the sticker (e.g. under the peel). */
  under?: ReactNode;
  /** Content riding on the vinyl above the face, e.g. a link printed on the curl. */
  over?: ReactNode;
}

/** A die-cut vinyl sticker on the backing sheet. See styles/components.css for the anatomy. */
export function Sticker({
  face,
  faceText,
  tilt = 0,
  shape = "rect",
  size = "md",
  peelable = false,
  className = "",
  faceClassName = "",
  style,
  children,
  under,
  over,
}: StickerProps) {
  return (
    <div
      className={`slot ${peelable ? "peelable" : ""} ${className}`}
      data-shape={shape}
      data-size={size}
      style={{ "--tilt": `${tilt}deg`, ...style } as CSSProperties}
    >
      {under}
      <div className="lift">
        <div className="sticker">
          <div
            className={`face ${faceClassName}`}
            style={{ "--face": face, "--face-text": faceText } as CSSProperties}
          >
            {children}
          </div>
        </div>
        <span className="curl" aria-hidden="true" />
        {over}
      </div>
    </div>
  );
}
